import { render, staticRenderFns } from "./manageLog.vue?vue&type=template&id=8810f544&scoped=true"
import script from "./manageLog.vue?vue&type=script&lang=js"
export * from "./manageLog.vue?vue&type=script&lang=js"
import style0 from "./manageLog.vue?vue&type=style&index=0&id=8810f544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8810f544",
  null
  
)

export default component.exports